import { z } from "zod";
import env from "@/app/config/env";

const availableLangList = JSON.parse(env.app.availableLangs);
export const defaultLang: string = env.app.defaultLang;

export const LocalizationDataSchema = z.record(z.string());
export type LocalizationDataType = z.infer<typeof LocalizationDataSchema>;

export const LocalizationDataKeySchema = z.string();
export type LocalizationDataKeyType = z.infer<typeof LocalizationDataKeySchema>;

export const LocalizationAvailableLangSchema = z.enum(
  availableLangList as [string, ...string[]],
);
export type LocalizationAvailableLangType = z.infer<
  typeof LocalizationAvailableLangSchema
>;

export const LocalizationDefaultLangSchema = z.enum([defaultLang] as [
  string,
  ...string[],
]);
export type LocalizationDefaultLangType = z.infer<
  typeof LocalizationDefaultLangSchema
>;
